import { c as _c } from "react/compiler-runtime";
// Значок «Проверенный продавец» (П7, fd-onboard-12): ИНН подтверждён реестром
// и приняты все обязательные документы. Флаг `verified` отдаёт шлюз в магазине.
import { BadgeCheck } from "lucide-react";
import { cn } from "@/lib/utils";
export function VerifiedSellerBadge(t0) {
  const $ = _c(9);
  const {
    compact: t1,
    className
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const t2 = !compact && "rounded-full bg-[#E8F5EC] px-2 py-1";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("inline-flex shrink-0 items-center gap-1 text-[13px] leading-4 font-medium text-[#1E8E3E]", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BadgeCheck className="size-4 shrink-0" aria-hidden="true" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== compact) {
    t5 = compact ? <span className="sr-only">{"\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0439 \u043F\u0440\u043E\u0434\u0430\u0432\u0435\u0446"}</span> : "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0439 \u043F\u0440\u043E\u0434\u0430\u0432\u0435\u0446";
    $[4] = compact;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <span className={t3} title={"\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0439 \u043F\u0440\u043E\u0434\u0430\u0432\u0435\u0446"} data-testid="verified-seller-badge">{t4}{t5}</span>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}